import { useAppDispatch } from '@/store'
import { Dialog } from '@/shared/ui'
import { setDialogs } from '@/store/sub_accounts'
import { VERIFICATION_ERROR_ALERT } from '@/entities/cabinet'
import style from '@/features/cabinet/ui/cabinet-alert-components/index.module.scss'

export function VerificationSuspendAlert({
    refuse_reason,
}: {
    refuse_reason: string
}) {
    const dispatch = useAppDispatch()
    return (
        <Dialog
            title={''}
            hideCloseBtn={true}
            onClose={() =>
                dispatch(
                    setDialogs({
                        key: VERIFICATION_ERROR_ALERT,
                        value: false,
                    })
                )
            }
            body={
                <div className={style.verification}>
                    <div>
                        <img
                            src={require('@/cabinet/images/warning.png')}
                            alt={'time'}
                        />
                    </div>
                    <div className={style.verification__content}>
                        <h5 className={style.verification__content__title}>
                            {' '}
                            Your account has been suspended
                        </h5>
                        <p className={style.verification__content__description}>
                            {refuse_reason ? (
                                refuse_reason
                            ) : (
                                <>
                                    Your mining access has been disabled. <br />{' '}
                                    Please check your email for more information
                                </>
                            )}
                        </p>
                    </div>
                </div>
            }
        />
    )
}
